// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"TemplateImage_imageContainer__36qUe","image":"TemplateImage_image__2OATE","small":"TemplateImage_small__3R8Hs"};